var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.actionText,
      hasAlert: "",
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "input",
          fn: function() {
            return [
              _c(
                "v-layout",
                { attrs: { warp: "" } },
                [
                  _c("v-autocomplete", {
                    staticClass: "required_field product_name",
                    attrs: {
                      items: _vm.products,
                      "item-text": "name",
                      "item-value": "id",
                      filter: _vm.customFilter,
                      label: _vm.$t("product"),
                      "prepend-icon": "devices_other",
                      rules: [_vm.fieldIsRequired("product")],
                      clearable: "",
                      disabled: _vm.editMode
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(data) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(data.item.id.slice(-5)) +
                                  " - " +
                                  _vm._s(
                                    data.item.condition &&
                                      data.item.condition.toUpperCase()
                                  ) +
                                  " - " +
                                  _vm._s(data.item.name)
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function(data) {
                          return [
                            _c("div", { attrs: { id: data.item.id } }, [
                              _vm._v(
                                _vm._s(data.item.id.slice(-5)) +
                                  " - " +
                                  _vm._s(
                                    data.item.condition &&
                                      data.item.condition.toUpperCase()
                                  ) +
                                  " - " +
                                  _vm._s(data.item.name)
                              )
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.newOffer.productId,
                      callback: function($$v) {
                        _vm.$set(_vm.newOffer, "productId", $$v)
                      },
                      expression: "newOffer.productId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { warp: "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("DatePicker", {
                        attrs: {
                          label: _vm.$t("expirationDate"),
                          "time-zone": "UTC"
                        },
                        model: {
                          value: _vm.newOffer.expirationDate,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "expirationDate", $$v)
                          },
                          expression: "newOffer.expirationDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "required_field",
                        attrs: {
                          label: _vm.$t("paymentPendingPeriod"),
                          rules: [
                            _vm.fieldIsRequired("pending period"),
                            _vm.fieldIsInteger("pending period"),
                            _vm.fieldIsNoLessThanZero("pending period")
                          ],
                          "prepend-icon": "dehaze",
                          readonly: _vm.editMode
                        },
                        model: {
                          value: _vm.newOffer.pendingPeriod,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "pendingPeriod", _vm._n($$v))
                          },
                          expression: "newOffer.pendingPeriod"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          id: "newOffer_quantity",
                          label: _vm.$t("quantity"),
                          "prepend-icon": "dehaze",
                          rules: _vm.quantityRules
                        },
                        model: {
                          value: _vm.newOffer.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "quantity", _vm._n($$v))
                          },
                          expression: "newOffer.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "required_field",
                        attrs: {
                          id: "newOffer_price",
                          label: _vm.$t("price"),
                          "prepend-icon": "attach_money",
                          rules: [
                            _vm.fieldIsNoLessThanZero("price"),
                            _vm.fieldIsRequired("price")
                          ]
                        },
                        model: {
                          value: _vm.newOffer.price,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "price", _vm._n($$v))
                          },
                          expression: "newOffer.price"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm4: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm4: "" } },
                            [
                              _c("v-switch", {
                                attrs: { label: _vm.$t("buyerLimit") },
                                model: {
                                  value: _vm.newOffer.isEnableQtyLimit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newOffer,
                                      "isEnableQtyLimit",
                                      $$v
                                    )
                                  },
                                  expression: "newOffer.isEnableQtyLimit"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm5: "" } },
                            [
                              _vm.newOffer.isEnableQtyLimit
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("maxQtyPerBuyer"),
                                      "prepend-icon": "dehaze",
                                      rules: _vm.newOffer.isEnableQtyLimit
                                        ? [
                                            _vm.fieldIsNoLessThanZero("limit"),
                                            _vm.fieldIsInteger("limit"),
                                            function(value) {
                                              return (
                                                !(
                                                  value &&
                                                  value > _vm.newOffer.quantity
                                                ) ||
                                                "Cannot be greater than the quantity"
                                              )
                                            }
                                          ]
                                        : []
                                    },
                                    model: {
                                      value: _vm.newOffer.acceptQtyLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newOffer,
                                          "acceptQtyLimit",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "newOffer.acceptQtyLimit"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { warp: "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm4: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: _vm.$t("onlyShipToWarehouse") },
                        on: {
                          change: function($event) {
                            return _vm.$refs.offerSites.validate()
                          }
                        },
                        model: {
                          value: _vm.newOffer.isOnlyShipToWarehouse,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "isOnlyShipToWarehouse", $$v)
                          },
                          expression: "newOffer.isOnlyShipToWarehouse"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.newOffer.isOnlyShipToWarehouse
                    ? [
                        _c(
                          "v-flex",
                          { attrs: { sm3: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                id: "newOffer_min_quantity",
                                label: _vm.$t("minSelf-storageQuantity"),
                                "prepend-icon": "dehaze",
                                rules: [
                                  _vm.fieldIsNoLessThanZero("min-quantity"),
                                  _vm.fieldIsInteger("min-quantity")
                                ]
                              },
                              model: {
                                value: _vm.newOffer.minQuantity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.newOffer,
                                    "minQuantity",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "newOffer.minQuantity"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { sm1: "" } }),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { sm3: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                id: "newOffer_bonus",
                                label: _vm.$t("bonus"),
                                "prepend-icon": "attach_money",
                                rules: [_vm.fieldIsNoLessThanZero("bonus")]
                              },
                              model: {
                                value: _vm.newOffer.bonus,
                                callback: function($$v) {
                                  _vm.$set(_vm.newOffer, "bonus", _vm._n($$v))
                                },
                                expression: "newOffer.bonus"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "", "align-center": "" } },
                [
                  _c("v-autocomplete", {
                    ref: "offerSites",
                    staticClass: "warehouse_name",
                    attrs: {
                      id: "offer_sites",
                      label: _vm.$t("selectedWarehouseSites"),
                      items: _vm.sites,
                      "item-value": "index",
                      "item-text": _vm.siteNameDisplay,
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      "return-object": "",
                      "prepend-inner-icon": "filter_list",
                      rules: [_vm.checkWarehouseSites]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function() {
                          return [
                            _c(
                              "v-list-tile",
                              {
                                attrs: { ripple: "" },
                                on: { click: _vm.selectAllSites }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color:
                                            _vm.newOffer.warehouseSites &&
                                            _vm.newOffer.warehouseSites.length >
                                              0
                                              ? "indigo darken-4"
                                              : ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.newOffer.warehouseSites &&
                                              _vm.newOffer.warehouseSites
                                                .length === _vm.sites.length
                                              ? "check_box"
                                              : _vm.newOffer.warehouseSites &&
                                                _vm.newOffer.warehouseSites
                                                  .length > 0
                                              ? "indeterminate_check_box"
                                              : "check_box_outline_blank"
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(_vm._s(_vm.$t("selectAll")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-divider", { staticClass: "mt-2" })
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.newOffer.warehouseSites,
                      callback: function($$v) {
                        _vm.$set(_vm.newOffer, "warehouseSites", $$v)
                      },
                      expression: "newOffer.warehouseSites"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: _vm.$t("visibleToAllMembers") },
                        model: {
                          value: _vm.newOffer.isPublic,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "isPublic", $$v)
                          },
                          expression: "newOffer.isPublic"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: _vm.$t("notifyMembers") },
                        model: {
                          value: _vm.newOffer.isNotifyMembers,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "isNotifyMembers", $$v)
                          },
                          expression: "newOffer.isNotifyMembers"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm1: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: _vm.$t("requiredServiceTag") },
                        model: {
                          value: _vm.newOffer.isRequiredServiceTag,
                          callback: function($$v) {
                            _vm.$set(_vm.newOffer, "isRequiredServiceTag", $$v)
                          },
                          expression: "newOffer.isRequiredServiceTag"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.newOffer.isPublic
                ? _c("v-autocomplete", {
                    ref: "offerEditAutocomplete",
                    attrs: {
                      items: _vm.members,
                      "item-text": "name",
                      "item-value": "key",
                      chips: "",
                      "deletable-chips": "",
                      multiple: "",
                      solo: "",
                      "return-object": "",
                      "prepend-inner-icon": "filter_list",
                      loading: _vm.$store.getters.loadingMembers
                    },
                    on: {
                      change: function($event) {
                        _vm.$refs.offerEditAutocomplete["lazySearch"] = ""
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              typeof data.item !== "object"
                                ? [
                                    _c("v-list-tile-content", {
                                      domProps: {
                                        textContent: _vm._s(data.item)
                                      }
                                    })
                                  ]
                                : [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          [
                                            data.item.isGroup
                                              ? _c("v-icon", [_vm._v("group")])
                                              : _c("v-icon", [
                                                  _vm._v("person")
                                                ]),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(data.item.name) +
                                                "\n            "
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4252107669
                    ),
                    model: {
                      value: _vm.newOffer.sendTo,
                      callback: function($$v) {
                        _vm.$set(_vm.newOffer, "sendTo", $$v)
                      },
                      expression: "newOffer.sendTo"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("v-textarea", {
                staticClass: "thinBox",
                attrs: {
                  id: "newOffer_note",
                  label: _vm.$t("note"),
                  outline: ""
                },
                model: {
                  value: _vm.newOffer.note,
                  callback: function($$v) {
                    _vm.$set(_vm.newOffer, "note", $$v)
                  },
                  expression: "newOffer.note"
                }
              })
            ]
          },
          proxy: true
        },
        _vm.editMode
          ? {
              key: "control1",
              fn: function() {
                return [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.moveToTop,
                        expression: "moveToTop"
                      }
                    ],
                    staticStyle: {
                      width: "20px",
                      height: "20px",
                      "vertical-align": "middle"
                    },
                    attrs: { type: "checkbox", id: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.moveToTop)
                        ? _vm._i(_vm.moveToTop, null) > -1
                        : _vm.moveToTop
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.moveToTop,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.moveToTop = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.moveToTop = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.moveToTop = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticStyle: { "font-size": "16px" },
                      attrs: { for: "checkbox" }
                    },
                    [_vm._v(_vm._s(_vm.$t("moveToTop")))]
                  )
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dbcb386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dbcb386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfferEdit.vue
// module id = null
// module chunks = 